import Contact from '../components/Contact';
import { translations } from '../mockData';

const ContactPage = ({ language }) => {
  const t = translations[language];
  return (
    <div className="pt-20">
      <Contact t={t} language={language} showForm={true} asPage />
    </div>
  );
};

export default ContactPage;
